export enum VatSuggestionsSource {
  FrontPage = 'front-page',
  ReportPage = 'report-page',
}

export const getVatSuggestionsSourceDisplayString = (source: VatSuggestionsSource): string => {
  switch (source) {
    case VatSuggestionsSource.FrontPage:
      return 'Front Page'
    case VatSuggestionsSource.ReportPage:
      return 'Report Page'
    default:
      return source
  }
}
